export default __webpack_public_path__ + "static/media/card-sip-icon.104a77bd.svg";